import type { SeverityLevel } from '@sentry/browser';

const SentrySeverity: Record<string, SeverityLevel> = {
  Fatal: 'fatal',
  Error: 'error',
  Warning: 'warning',
  Log: 'log',
  Info: 'info',
  Debug: 'debug',
};

Object.freeze(SentrySeverity);

export default SentrySeverity;
